"use client";

import React, { useState, useRef, useEffect } from "react";
import TextBox from "../../components/TextBox/TextBox";
import Button from "../../components/Button/Button";
import CheckBox from "../../components/CheckBox/CheckBox";
import ReCAPTCHA from "react-google-recaptcha";
import { Post as PostCall } from "../../services/ClientSideAPIService";
import Post from "../../constants/Post";
import browser from "../../utils/browser";
import Sites from "../../constants/Sites";
import {
  readCookie,
  setCookie,
  doubleOptinParkingList,
  SiteName_SiteID_Map,
  getThankYouMessage,
  findSiteNameWithoutCom,
  addTimeInMinutes,
  validateEmailFormat,
} from "../../helpers/Helper";
import { useAppContext } from "@components/Provider";

import contentCateStyles from "../CategoryPage/ContentCategory.module.css";
import styles from "./NewsletterV2.module.css";
import "./NewsletterV2.css";

const NewsletterV2 = (props) => {
  const defaultProps = {
    signUpLocation: "",
    primaryNewsletter: [],
    optInNewsletter: "",
    primarySailthruEmailTemplate: "",
    textBoxPlaceholder: "enter your email",
    buttonText: "Subscribe",
    buttonLoadingText: "Subscribing...",
    newsletterCopy: "",
    newsletterSubCopy: null,
    newsletterSubFooter: null,
    newsletterAddImage: null,
    classNames: "",
    isGiveaway: false,
    authorId: 0,
    followButton: false,
    OptIn: true,
    queryString: "",
    inlineStyles: { button: { backgroundColor: "#2C68B0" } },
  };

  props = { ...defaultProps, ...props };

  const { siteId, li_did } = useAppContext();
  const [state, setState] = useState({
    loading: false, // E.L bool flag used to keep track of the ajax request
    isOptInChecked: props?.OptIn == true && props?.optInNewsletter?.partnerCheckbox ? true : false,

    displayError: false,
    errorMsg: "",
    successMsg: "", //use to show the success message for author follow
  });

  const errorMsg = "You are already subscribed. Check your inbox for our daily emails.";

  useEffect(() => {
    if (props.OptIn && props.isOptInChecked)
      setState((prevState) => ({
        ...prevState,
        isOptInChecked: props.isOptInChecked,
      }));
  }, [props.isOptInChecked]);

  useEffect(() => {
    if (state.successMsg) {
      setTimeout(() => {
        setState((prevState) => ({
          ...prevState,
          successMsg: "",
        }));
      }, 3000);
      if (props?.toggleModal) window.location.reload();
    }
  }, [state.successMsg]);

  const newsletterEmailRef = useRef(null);
  const optInRef = useRef(null);
  const recaptchaRef = useRef(null);

  const renderNewsletterHeaderCopy = () => {
    const headerCopy =
      props?.subComponentType === "modal"
        ? (props?.modalHeader ?? props?.header)
        : props?.header || "";
    if (headerCopy) {
      let newsletterHeaderCopy = headerCopy;
      return (
        <>
          <div
            className={
              props?.subComponentType === "modal"
                ? styles["newsletter-modal-header"]
                : "newsletter-copy " + props.newsletterCopyClass
            }
            dangerouslySetInnerHTML={{
              __html: newsletterHeaderCopy,
            }}
          ></div>
        </>
      );
    }
  };
  const renderNewsletterSubHeaderCopy = () => {
    const subHeaderCopy =
      props?.subComponentType === "modal"
        ? (props?.modalSubHeader ?? props?.subHeader)
        : props?.subHeader || "";
    if (subHeaderCopy) {
      return (
        <>
          <div
            className={
              props?.subComponentType === "modal"
                ? `${styles["newsletter-modal-content"]} newsletter-modal-content`
                : "newsletter-copy " + props.newsletterCopyClass
            }
            dangerouslySetInnerHTML={{
              __html: `<p>${subHeaderCopy}</p>`,
            }}
          />
        </>
      );
    }
  };

  const handleError = (error) => {
    if (error) {
      if (props?.getSignUpStatus) props?.getSignUpStatus(false);
      let errorMsg = error.SailThruResponse?.message
        ? error.SailThruResponse?.message
        : "An Error occurred while subscribing to newsletter.";
      setState((prevState) => ({
        ...prevState,
        loading: false,
        displayError: true,
        errorMsg,
      }));
    }
  };

  const trackSubmit = () => {
    window.uetq = window.uetq || [];
    window.uetq.push({
      ec: "BingAd",
      ea: "NewsletterSignup",
      el: "PrimaryFunnel",
      ev: 1,
    });

    if (browser.isClient()) {
      const action = "newsletter-component-submission";
      const payload = {
        signupLocation: props?.signUpLocation,
        email: newsletterEmailRef.current.state.value,
      };
      if (typeof window != "undefined") {
        //window.ga('orim180.send', 'event', payload);
        //Converting it to Datalayer push instead of GA Event as part of https://openroadmedia.atlassian.net/browse/ORMTECH-796
        window.dataLayer.push({ event: action, ...payload });
      }
    }
  };

  const handleLDLSuccess = (res) => {
    console.log(res);
  };
  const handleLDLError = (err) => {
    console.log(err);
  };

  const sendLDLEmail = async () => {
    await PostCall(
      "ldlOutsideBook",
      {
        data: {
          email: newsletterEmailRef.current.state.value,
          ldlOutSideBook: true,
          sourceTitle: props.sourceTitle,
          lhRate: props.lhRate,
          lhMedium: props.lhMedium,
        },
        siteId: siteId,
      },
      handleLDLSuccess,
      handleLDLError
    );
  };

  const handleSuccess = (response) => {
    const { res, token } = response;
    let redirectUrl = props?.thankYou?.queryString
        ? `${props?.thankYou.redirectUrl}?${props?.thankYou?.queryString}`
        : props?.thankYou?.redirectUrl,
      thankYouMessage = props?.thankYou?.message;
    if (props.ldl) sendLDLEmail();
    setState((prevState) => ({ ...prevState, loading: false }));
    if (optInRef?.current?.state?.value) {
      optInRef.current.state.value.clearCheckBox();
    }
    const { userAlreadyExist } = res && res.MongoResponse && res.MongoResponse.info;

    if (!props?.followButton) {
      const { email } = res && res.MongoResponse && res.MongoResponse.info;
      if (props?.Newsletter_Settings && props?.Newsletter_Settings.enabled) {
        let preferencesRedirect = "/account/welcome";
        if (!userAlreadyExist) {
          trackSubmit();
          if (browser.isClient()) {
            setCookie("subscribed", email, process.env.SUBSCRIBED_COOKIE_EXPIRY_DAYS);
            setCookie("ormtoken", token, process.env.SUBSCRIBED_COOKIE_EXPIRY_DAYS);
            setCookie("wasloggedin", true, process.env.SUBSCRIBED_COOKIE_EXPIRY_DAYS);
          }
          if (!props?.skipPreferenceCenter && props?.signUpLocation !== "Header") {
            window.location.href = preferencesRedirect;
          } else {
            redirectUrl
              ? (window.location.href = `/${redirectUrl}`)
              : setState((prevState) => ({
                  ...prevState,
                  successMsg: thankYouMessage
                    ? thankYouMessage
                    : getThankYouMessage(siteId, props?.ldl || false),
                }));
          }
        } else {
          if (browser.isClient()) {
            setCookie("subscribed", email, process.env.SUBSCRIBED_COOKIE_EXPIRY_DAYS);
          }
          if (props?.isGiveaway && redirectUrl) {
            window.location.href = `/${redirectUrl}`;
          } else {
            if (props?.post_type === Post.TYPES.EBB_HOMEPAGE) {
              setState((prevState) => ({
                ...prevState,
                displayError: true,
                errorMsg: "You are already subscribed. Redirecting to today's deals!",
              }));
              setTimeout(() => {
                window.location.href = `/${redirectUrl}`;
              }, 3000);
            } else {
              setState((prevState) => ({ ...prevState, displayError: true }));
            }
          }
        }
        // end failed logic
      } else {
        if (browser.isClient()) {
          email && setCookie("subscribed", email, process.env.SUBSCRIBED_COOKIE_EXPIRY_DAYS);
          setCookie("ormtoken", token, process.env.SUBSCRIBED_COOKIE_EXPIRY_DAYS);
          setCookie("wasLoggedIn", true, process.env.SUBSCRIBED_COOKIE_EXPIRY_DAYS);
        }
        trackSubmit();
        if (props?.signUpLocation != "Header") {
          redirectUrl
            ? (window.location.href = `/${redirectUrl}`)
            : setState((prevState) => ({
                ...prevState,
                successMsg: thankYouMessage
                  ? thankYouMessage
                  : getThankYouMessage(
                      siteId,
                      props.ldl || false,
                      newsletterEmailRef.current.state.value
                    ),
              }));
        } else {
          setState((prevState) => ({
            ...prevState,
            successMsg: "You are subscribed successfully.",
            displayError: false,
            errorMsg: "",
          }));
        }
        return;
      }
    } else {
      trackSubmit();
      if (
        res &&
        res.SailThruResponse &&
        (res.SailThruResponse.status === 200 || res.SailThruResponse.status === 201) &&
        res.MongoResponse &&
        (res.MongoResponse.status === 200 || res.MongoResponse.status === 201)
      ) {
        setState((prevState) => ({
          ...prevState,
          successMsg: "You have successfully followed",
          displayError: false,
          errorMsg: "",
        }));
      } else {
        setState((prevState) => ({
          ...prevState,
          displayError: true,
          errorMsg: res.SailThruResponse?.message,
          successMsg: "",
        }));
      }
    }
  };

  const isValid = () => validateEmailFormat(newsletterEmailRef.current.state.value);

  const optInPreferences = () => {
    // Default newsletter option
    if (!props?.optInNewsletter?.optInSite?.trim()) {
      return "";
    }
    // Optional opt-in Newsletter
    return state.isOptInChecked ? "yes" : "no";
  };

  const populateSailthruUserVars = (nl_name, optin) => {
    let tracking_cookie = readCookie("utm_params");
    let utmParams = tracking_cookie ? JSON.parse(tracking_cookie) : {},
      signupLocation = props?.signUpLocation,
      giveawaySource = [],
      listName;
    if (props?.isGiveaway) {
      let partnerName = "";
      if (state.isOptInChecked && props?.optInNewsletter?.optInSite) {
        partnerName = props?.optInNewsletter?.optInSite;
      }
      giveawaySource.push({
        name: `giveaway_${signupLocation}`,
        partner: partnerName,
      });
    }

    //Checking against parkinglist object defined at top to fetch
    //SailThru list name for Double opt-in
    if (siteId !== Sites.EARLYBIRDBOOKS && !props?.addNewPartner) {
      listName = doubleOptinParkingList()[props?.optInNewsletter.optInSite]?.name;
    }

    //So If not primary newsletter signup, check parking list and send
    //parking list as list to add user
    if (optin && (listName || props?.optInNewsletter.optInSiteSailthruLists?.length > 0)) {
      //If it is double opt-in, we need to set different utmParams
      let optInReferralSourceUtmParam =
        doubleOptinParkingList()[findSiteNameWithoutCom(siteId)].utm_param;
      if (optInReferralSourceUtmParam) {
        utmParams["referral_source"] = optInReferralSourceUtmParam;
      }
      const defaultOptInSignupParams = {
        site_id: SiteName_SiteID_Map(nl_name),
        lists: { [listName]: 1 },
        vars: {
          signup_location: signupLocation,
          giveaway_source: giveawaySource,
          slug: browser.getHostname(),
          referrer: browser.getReferrer(),
          partner_checkbox: optInPreferences(),
          email_frequency: "Default",
          ...utmParams,
        },
      };
      const optInSailthruLists = {};
      if (
        Array.isArray(props?.optInNewsletter.optInSiteSailthruLists) &&
        props?.optInNewsletter.optInSiteSailthruLists.length > 0
      ) {
        props?.optInNewsletter.optInSiteSailthruLists.forEach((el) => {
          optInSailthruLists[el] = 1;
        });
        defaultOptInSignupParams.lists = optInSailthruLists;
      }
      return defaultOptInSignupParams;
    }
    const defaultSignupParams = {
      site_id: SiteName_SiteID_Map(nl_name),
      vars: {
        signup_location: signupLocation,
        giveaway_source: giveawaySource,
        slug: browser.getHostname(),
        referrer: browser.getReferrer(),
        partner_checkbox: optInPreferences(),
        email_frequency: "Default",
        ...utmParams,
        ...props?.additionalVars,
      },
    };
    if (!props?.skipPreferenceCenter && props?.signUpLocation !== "Header") {
      defaultSignupParams.vars.schedule_time = addTimeInMinutes(
        process.env.SCHEDULE_WELCOME_NEWSLETTER_TIME_IN_MINUTES
      );
    }
    let userSailthruLists = {};
    if (Array.isArray(props?.primaryNewsletter) && props?.primaryNewsletter.length > 0) {
      props?.primaryNewsletter.forEach((el) => {
        userSailthruLists[el] = 1;
      });
      defaultSignupParams.lists = userSailthruLists;
    }
    return defaultSignupParams;
  };
  const handleCaptchaError = (err) => {
    console.log(err);
  };
  const handleSubmit = async () => {
    if (isValid() && newsletterEmailRef.current.state.value) {
      setState((prevState) => ({
        ...prevState,
        loading: true,
        displayError: false,
        errorMsg: "",
        successMsg: "",
      }));
      let params = {};
      /*we are passing site id as 1 when a user tries to signup for catalog site, 
      as there is no dedicated newsletter for the catalog site(openroadmedia).
      For more information, please take a look here: https://openroadmedia.atlassian.net/browse/ORMTECH-1726
      */
      params.newsletters = [
        {
          name: findSiteNameWithoutCom(
            siteId === Sites.OPENROADMEDIA ? Sites.EARLYBIRDBOOKS : siteId
          ),
          shouldSendEmail: true,
          sailthruEmailTemplate: props?.welcomeEmailTemplate,
          userOptionalParams: populateSailthruUserVars(findSiteNameWithoutCom(siteId)),
        },
      ];

      // options for the OPT-IN Newsletter
      if (state.isOptInChecked && props?.optInNewsletter.optInSite && !props?.addNewPartner) {
        params.newsletters.push({
          name: props?.optInNewsletter.optInSite,
          shouldSendEmail: false, //For double opt-in, don't send welcome email
          userOptionalParams: populateSailthruUserVars(props?.optInNewsletter.optInSite, true),
        });
      }
      const signupParams = {
        ...params,
        followButton: props?.followButton,
        author_id: props?.authorId,
        author_name: props?.authorName,
        email: newsletterEmailRef?.current?.state?.value?.trim(),
        li_did: li_did || "",
      };

      if (process.env.GOOGLE_RECAPTCHA_ENABLE == "true") {
        const captchaToken = await recaptchaRef.current.executeAsync();
        let tokenData = { gToken: captchaToken };
        let captchaVerification =
          (await PostCall(
            "gverify",
            { data: tokenData, siteId: siteId },
            null,
            handleCaptchaError,
            "Post",
            false
          )) || "";

        //Continue with sign up if captcha validation is successful
        if (
          captchaVerification &&
          captchaVerification.status &&
          captchaVerification.status === 200
        ) {
          // console.log("captchaToken ", captchaToken);
          // console.log("Captcha Verification successful");
          //E.L prepare ajax request to our newsletter-signup endpoint in api
          await PostCall(
            "SignUp",
            { data: signupParams, siteId: siteId },
            handleSuccess,
            handleError
          );
        } else {
          //console.log("Captcha Verification Fail");
          let errorMsg = "Something went wrong with ReCaptcha validation. Please try again later.";
          recaptchaRef.current.reset();
          setState((prevState) => ({
            ...prevState,
            loading: false,
            displayError: true,
            errorMsg,
          }));
        }
        recaptchaRef.current.reset();
      } else {
        await PostCall(
          "SignUp",
          { data: signupParams, siteId: siteId },
          handleSuccess,
          handleError
        );
      }
    } else {
      setState((prevState) => ({
        ...prevState,
        displayError: true,
        errorMsg: "Please provide valid email address",
        successMsg: "",
      }));
    }
  };

  const handleOptInChange = (evt) => {
    setState((prevState) => ({
      ...prevState,
      isOptInChecked: evt.target.checked,
    }));
  };

  const renderOptIn = () => {
    if (props?.optInNewsletter?.optInSite && props?.optInNewsletter?.optInNewsletterCopy?.trim()) {
      return (
        <div className={styles.checkBox}>
          <CheckBox
            ref={optInRef}
            isChecked={state.isOptInChecked}
            onChange={handleOptInChange}
            value={props?.optInNewsletter.optInNewsletterCopy}
            label={props?.optInNewsletter.optInNewsletterCopy}
          />
        </div>
      );
    } else {
      return <div></div>;
    }
  };

  const formattedClassNames =
    props?.classNames
      .split(" ")
      .map((className) => styles[className])
      .join(" ") +
    " " +
    props?.classNames;

  return (
    <div className={`${formattedClassNames || "newsletter-comp"} row`}>
      {renderNewsletterHeaderCopy()}
      {renderNewsletterSubHeaderCopy()}
      {props?.newsletterSubCopy ? (
        <div className="nl-subcopy">{props.newsletterSubCopy}</div>
      ) : null}
      {props?.newsletterAddImage ? (
        <div className={styles.newsletterAddImage}>
          <img src={props?.newsletterAddImage} alt="" />
        </div>
      ) : null}
      <div className={`formGroup ${props.formGroupClasses}`}>
        <div
          className={`${styles.newLetterContainer} newLetterContainer newsletter_with_image_container ${props.newLetterContainerClasses}`}
        >
          <div
            className={`${styles.inputBox} inputBox newsletter_with_image_inputBox ${props.inputBoxClasses}`}
          >
            <TextBox
              onEnter={handleSubmit}
              className={`${props?.classNames} newOne`}
              placeholder={props.textBoxPlaceholder}
              name="newsletterEmail"
              ref={newsletterEmailRef}
              rules={[{ type: "email" }]}
              errorMessage={state.displayError ? state.errorMsg || errorMsg : null}
              successMessage={state.successMsg ? state.successMsg : ""}
              handleIsValid={(el) => console.log(el)}
              isEBBHomePage={props?.post_type === Post.TYPES.HOMEPAGE}
              disabled={props.disabled}
              textBoxInputClass={props.textBoxInputClass}
              parentClass={{
                successClass: props.successClass,
                msgBlockClass: props.msgBlockClass,
              }}
            />
          </div>
          <div
            className={`${styles.buttonBox} buttonBox ${props.buttonBoxClasses} ${
              props?.modalWithImageProps?.image?.url ? "newsletter_with_image_button" : ""
            }`}
          >
            <div className="button-wrapper">
              <Button
                text={state.loading ? props?.buttonLoadingText : props?.buttonText || "Subscribe"}
                handleClick={handleSubmit}
                classes={[formattedClassNames, "newOne", "plusFont"].join(" ")}
                disabled={props.disabled}
                buttonBoxButtonClass={props.buttonBoxButtonClass}
                inlineStyles={props.inlineStyles?.button}
              />
              {process.env.GOOGLE_RECAPTCHA_ENABLE == "true" && (
                <ReCAPTCHA
                  style={{ display: "none" }}
                  ref={recaptchaRef}
                  size="invisible"
                  sitekey={process.env.GOOGLE_RECAPTCHA_SITEKEY}
                  badge="inline"
                />
              )}
            </div>
          </div>
        </div>
        {props?.newsletterSubFooter ? (
          <div
            className="nl-subfooter"
            dangerouslySetInnerHTML={{
              __html: props?.newsletterSubFooter,
            }}
          ></div>
        ) : null}
        {!props?.modalWithImageProps?.image?.url && (
          <div className={`${contentCateStyles.newsLFooter} newsLFooter`}>
            {props?.OptIn !== false && renderOptIn()}
          </div>
        )}
      </div>
    </div>
  );
};

// NewsletterV2.Layout = App.Layout;
NewsletterV2.displayName = "NewsletterV2";

export default NewsletterV2;
